module.exports = __webpack_public_path__ + "static/media/icon-user-sq.e9cea28a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-user-sq.svg
// module id = 239
// module chunks = 0